import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/database';
import Swal from 'sweetalert';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const storage = firebase.storage();
const database = firebase.database();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const ANO = localStorage.getItem('anoFiltrado');
const ANOnormal = localStorage.getItem('ano');
if (!ANO) {
    localStorage.setItem('anoFiltrado', ANOnormal);
}

const horas = dataAtual.getHours();
const minutos = dataAtual.getMinutes();
const hora = `${horas < 10 ? '0' : ''}${horas}:${minutos < 10 ? '0' : ''}${minutos}`;
            
const lerTodosAlunos = async () => {
    return new Promise( async (resolve, reject) => {
        const alunos = [];
        try {
            const ANO = await localStorage.getItem('anoFiltrado');

            const seriesData = await db.collection(ANO)
            .doc('series')
            .collection('existente')
            .get();
            
            
            const seriesPromises = seriesData.docs.map( async (val) => {
                const serie = val.id;
                const alunosList = await lerAlunos(serie);
                alunosList.forEach(aluno => {
                    alunos.push(aluno);
                });
            });

            await Promise.all(seriesPromises);

            resolve(alunos);
        } catch (error) {
            console.log('erro', error);
            reject(error);
        }
    });
};

const lerAlunos = async (serie) => {
    return new Promise( async (resolve, reject) => {
        const alunos = [];
        try {

            const ANO = await localStorage.getItem('anoFiltrado');

            await db.collection(ANO)
            .doc('series')
            .collection(serie)
            .onSnapshot((data) => {
                data.docs.map((val) => {
                    const aluno = val.data().aluno;
                    const responsavel = val.data().responsavel;
                    const onesignalId = val.data().onesignalId;
                    alunos.push({
                        aluno: aluno,
                        responsavel: responsavel,
                        serie: serie,
                        onesignalId: onesignalId,
                    });
                });
                resolve(alunos);
            });
        } catch {
            console.log('erro')
        }
    });
};

const lerResponsavel = async (responsavel) => {
    return new Promise( async (resolve, reject) => {
        const dados = [];
        try {

            const ANO = await localStorage.getItem('anoFiltrado');

            await db.collection(ANO)
            .doc('responsaveis')
            .collection(responsavel)
            .onSnapshot((data) => {
                data.docs.map( async (val) => {
                    const aluno = val.data().aluno;
                    const responsavel = val.data().responsavel;
                    const email = val.data().email;
                    const ra = val.data().ra;
                    const senha = val.data().senha;
                    const senhaSed = val.data().senhaSed;
                    const telefoneResponsavel = val.data().telefoneResponsavel;
                    const telefoneAluno = val.data().telefoneAluno;
                    const serie = val.data().serie;
                    const nascimentoAluno = val.data().nascimentoAluno;
                    const onesignalId = val.data().onesignalId;
                    const imagem = val.data().imagem;
                    const imagemRef = await storage.ref(`${ANO}/responsaveis/${responsavel}/${imagem}`);
                    var fotoDePerfil = '';
                    try {
                        const metadata = await imagemRef.getMetadata();
                        
                        // Se chegou aqui, o objeto existe
                        fotoDePerfil = await imagemRef.getDownloadURL();
                        console.log(fotoDePerfil)
                    } catch (error) {
                        console.log(error)
                    }
                    dados.push({
                        aluno: aluno,
                        responsavel: responsavel,
                        serie: serie,
                        email: email,
                        ra: ra,
                        senha: senha,
                        senhaSed: senhaSed,
                        telefoneResponsavel: telefoneResponsavel,
                        telefoneAluno: telefoneAluno,
                        nascimentoAluno: nascimentoAluno,
                        onesignalId: onesignalId,
                        fotoDePerfil: fotoDePerfil,
                    });
                });
                resolve(dados);
            });
        } catch {
            reject('error');
            console.log('erro nos dados do responsável')
        }
    });
};

const lerMensagensDoResponsavel = async (responsavel, serie, servidor) => {
    return new Promise( async (resolve, reject) => {
        const mensagens = [];
        try {
            const ANO = await localStorage.getItem('anoFiltrado');
            const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagens${servidor}`);
            mensagensRef.limitToLast(30).on('child_added', (snapshot) => {
                const mensagemId = snapshot.key;
                const mensagem = snapshot.val();

                const mensagemObj = {
                    mensagem: mensagem.mensagem,
                    hora: mensagem.hora,
                    usuario: mensagem.usuario,
                    view: mensagem.view,
                    id: mensagemId,
                    servidor: servidor,
                };
                mensagens.push(mensagemObj);
            });
            mensagensRef.on('value', () => {
                resolve(mensagens);
            });
        } catch (error) {
            reject(error);
            console.error('Erro ao obter mensagens:', error);
        }
    });
};

const lerMensagensDoServidor = async (responsavel, serie, servidor) => {
    return new Promise( async (resolve, reject) => {
        const mensagens = [];
        try {
            const ANO = await localStorage.getItem('anoFiltrado');
            const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagens${servidor}`);

            mensagensRef.limitToLast(30).on('child_added', (snapshot) => {
                const mensagemId = snapshot.key;
                const mensagem = snapshot.val();

                const mensagemObj = {
                    mensagem: mensagem.mensagem,
                    hora: mensagem.hora,
                    usuario: mensagem.usuario,
                    id: mensagemId,
                    servidor: mensagem.servidor,
                };
                mensagens.push(mensagemObj); 
            });
            mensagensRef.on('value', () => {
                resolve(mensagens);
            });
        } catch (error) {
            reject(error);
            console.error('Erro ao obter mensagens:', error);
        }
    });
}

const enviarMensagemParaResponsavel = async (responsavel, serie, servidor, mensagem, onesignalId) => {

    if (mensagem && mensagem !== '') {

        return new Promise( async (resolve, reject) => {
            
            const ANO = await localStorage.getItem('anoFiltrado');

            await enviarNotificacaoParaResponsavel(mensagem, onesignalId);
            
            const responsavelRef = database.ref(`${ANO}/chat/${serie}/${responsavel}`);
            await responsavelRef.update({ nome: responsavel });
            
            const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagens${servidor}`);
            await mensagensRef.push({
                hora: hora,
                usuario: servidor,
                mensagem: mensagem,
                data: firebase.database.ServerValue.TIMESTAMP,
                servidor: servidor,
                serie: serie,
            });

            const notificationRef = database.ref(`${ANO}/notification/${responsavel}`);
            await notificationRef.push({
                hora: hora,
                usuario: servidor,
                mensagem: mensagem,
                data: firebase.database.ServerValue.TIMESTAMP,
                servidor: servidor,
                serie: serie,
            });

            const serieExistenteRef = database.ref(`${ANO}/chat/existente/${serie}`);
            await serieExistenteRef.update({ serie: serie });

            resolve(true);
        });

    } else {
        await Swal({
            title: 'Digite uma mensagem!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
        });
    }
}

// PARA RESPONSAVEL
const enviarMensagemParaServidor = async (responsavel, serie, servidor, mensagem) => {
    
    if (mensagem && mensagem !== '') {
     
        return new Promise( async (resolve, reject) => {
        
            const ANO = await localStorage.getItem('anoFiltrado');

            await db.collection(ANO)
            .doc('restrito')
            .collection(servidor)
            .doc('login')
            .collection('acessos')
            .onSnapshot((data) => {
                data.docs.map( async (val) => {
                    const onesignalId = val.data().onesignalId;
                    await enviarNotificacaoParaServidor(responsavel, mensagem, onesignalId);
                });
            });

            const responsavelRef = database.ref(`${ANO}/chat/${serie}/${responsavel}`);
            await responsavelRef.update({ nome: responsavel });

            const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagens${servidor}`);
            await mensagensRef.push({
                hora: hora,
                usuario: responsavel,
                mensagem: mensagem,
                data: firebase.database.ServerValue.TIMESTAMP,
                servidor: servidor,
                serie: serie,
            });

            const notificationRef = database.ref(`${ANO}/notification/${servidor}`);
            await notificationRef.push({
                hora: hora,
                usuario: responsavel,
                mensagem: mensagem,
                data: firebase.database.ServerValue.TIMESTAMP,
                servidor: servidor,
                serie: serie,
            });

            const serieExistenteRef = database.ref(`${ANO}/chat/existente/${serie}`);
            await serieExistenteRef.update({ serie: serie });

            resolve(true);
        });

    } else {
        await Swal({
            title: 'Digite uma mensagem!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
        });
    }

}

// PARA PROFESSOR
const enviarMensagemDoProfessor = async (serie, dados, mensagem, professor) => {
            
    if (mensagem && mensagem !== '' && serie && dados) {
        
        return new Promise( async (resolve, reject) => {
            
            const ANO = await localStorage.getItem('anoFiltrado');
            
            if (dados.length > 0) {
                dados.forEach( async (dado) => {

                    const responsavel = dado.responsavel;
                    const aluno = dado.aluno;
                    var onesignalId = '';
                    if (dado.onesignalId) {
                        onesignalId = dado.onesignalId;
                    }

                    const mensagensRef = database.ref(`${ANO}/aprovarMensagem`);
                    await mensagensRef.push({
                        hora: hora,
                        usuario: professor,
                        mensagem: mensagem,
                        responsavel: responsavel,
                        aluno: aluno,
                        data: firebase.database.ServerValue.TIMESTAMP,
                        servidor: 'professor',
                        serie: serie,
                        onesignalId: onesignalId,
                    });

                    await Swal({
                        title: 'Mensagem enviada com sucesso, aguarde a aprovação da direção!',
                        icon: 'success',
                        buttons: {
                            confirm: 'Sim',
                        },
                    }).then((res) => {
                        window.location.reload();
                    });

                }); 

                resolve(true);
            } else {
                await Swal({
                    title: 'Escolha pelo menos um aluno!',
                    icon: 'error',
                    buttons: {
                      confirm: 'Ok',
                    },
                });
            } 
        });

    } else {
        await Swal({
            title: 'Complete o formulário corretamente!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
        });
    }
    

}


// PARA RESPONSAVEL
const enviarMensagemDoResponsavel = async (serie, aluno, mensagem, responsavel) => {

    if (mensagem && mensagem !== '') {
        
        return new Promise( async (resolve, reject) => {
            
            const ANO = await localStorage.getItem('anoFiltrado');

            const mensagensRef = database.ref(`${ANO}/aprovarMensagem`);
            await mensagensRef.push({
                hora: hora,
                usuario: responsavel,
                mensagem: mensagem,
                responsavel: responsavel,
                aluno: aluno,
                data: firebase.database.ServerValue.TIMESTAMP,
                servidor: 'responsavel',
                serie: serie,
            });

            await Swal({
                title: 'Mensagem enviada com sucesso, aguarde a aprovação da direção!',
                icon: 'success',
                buttons: {
                    confirm: 'Sim',
                },
            }).then((res) => {
                window.location.reload();
            });

            resolve(true);
        
        });

    } else {
        await Swal({
            title: 'Digite uma mensagem!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
        });
    }
    

}

// ONESIGNAL

// PARA RESPONSAVEL
const enviarNotificacaoParaServidor = async (responsavel, mensagem, onesignalId) => {
    return new Promise( async (resolve, reject) => {
        try {
            const notificationData = {
                app_id: '4f32f773-6836-46ab-b823-c411e07ae41f', // Substitua pelo ID do seu aplicativo OneSignal
                headings: {
                    en: 'Letícia Ensino Médio',
                    pt: 'Letícia Ensino Médio',
                },
                contents: {
                    en: `${responsavel}: ${mensagem}`,
                    pt: `${responsavel}: ${mensagem}`,
                },
                include_subscription_ids: [onesignalId],
            };

            await fetch('https://onesignal.com/api/v1/notifications', {
                method: 'POST',
                headers: {
                    Authorization: 'Basic MWMzNDM4YzAtNjI1Ny00MGM0LWE2YTMtYTFhMjgzMzE1ZTZm', // Substitua pelo sua chave da API REST do OneSignal
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(notificationData),
                })
                .then((data) => {
                    resolve(true);
                    console.log('Notificação enviada com sucesso:', data);
                })
                .catch(error => {
                    reject(error);
                    console.error('Erro ao enviar a notificação:', error);
                });
        } catch (error) {
            console.log(error);
        }
    });
}

// PARA SERVIDOR
const enviarNotificacaoParaResponsavel = async (mensagem, onesignalId) => {
    return new Promise( async (resolve, reject) => {
        try {
            const notificationData = {
                app_id: '4f32f773-6836-46ab-b823-c411e07ae41f', // Substitua pelo ID do seu aplicativo OneSignal
                headings: {
                    en: 'Letícia Ensino Médio',
                    pt: 'Letícia Ensino Médio',
                },
                contents: {
                    en: `Mensagem: ${mensagem}`,
                    pt: `Mensagem: ${mensagem}`,
                },
                include_subscription_ids: [onesignalId],
            };

            await fetch('https://onesignal.com/api/v1/notifications', {
                method: 'POST',
                headers: {
                    Authorization: 'Basic MWMzNDM4YzAtNjI1Ny00MGM0LWE2YTMtYTFhMjgzMzE1ZTZm', // Substitua pelo sua chave da API REST do OneSignal
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(notificationData),
                })
                .then((data) => {
                    resolve(true);
                    console.log('Notificação enviada com sucesso:', data);
                })
                .catch(error => {
                    reject(error);
                    console.error('Erro ao enviar a notificação:', error);
                });
                
        } catch (error) {
            console.log(error);
        }
    });
}

const enviarNotificacaoParaTodos = async (tipo, mensagem) => {
    return new Promise( async (resolve, reject) => {
        try {
            const notificationData = {
                app_id: '4f32f773-6836-46ab-b823-c411e07ae41f',
                headings: {
                    en: 'Letícia Ensino Médio',
                    pt: 'Letícia Ensino Médio',
                },
                contents: {
                    en: `${tipo}: ${mensagem}`,
                    pt: `${tipo}: ${mensagem}`,
                },
                included_segments: ['All'],
            };

            await fetch('https://onesignal.com/api/v1/notifications', {
                method: 'POST',
                headers: {
                    Authorization: 'Basic MWMzNDM4YzAtNjI1Ny00MGM0LWE2YTMtYTFhMjgzMzE1ZTZm', // Substitua pelo sua chave da API REST do OneSignal
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(notificationData),
                })
                .then((data) => {
                    resolve(true);
                    console.log('Notificação enviada com sucesso:', data);
                })
                .catch(error => {
                    reject(false);
                    console.error('Erro ao enviar a notificação:', error);
                });
        } catch (error) {
            console.log(error);
        }
    });
}

const enviarMensagemEmMassa = async (destinatario, mensagem, dados) => {
    try {
        const dataAtual = new Date();
        const horas = dataAtual.getHours();
        const minutos = dataAtual.getMinutes();
        const hora = `${horas < 10 ? '0' : ''}${horas}:${minutos < 10 ? '0' : ''}${minutos}`;

        const servidor = localStorage.getItem('logado');

        if (destinatario) {
            if (mensagem) {
                if (destinatario === 'todos') {
                    
                    return new Promise( async (resolve, reject) => {
                        
                        const ANO = await localStorage.getItem('anoFiltrado');

                        const snapshot = await db.collection(ANO)
                            .doc('series')
                            .collection('existente')
                            .get();

                        snapshot.forEach(async (doc) => {
                            const serie = doc.id;
                        
                            const serieSnapshot = await db.collection(ANO)
                                .doc('series')
                                .collection(serie)
                                .get();
                        
                            const promises = [];
                        
                            serieSnapshot.forEach(async (doc) => {
                                const responsavel = doc.data().responsavel;
                                const onesignalId = doc.data().onesignalId;
                        
                                promises.push(enviarMensagemParaResponsavel(responsavel, serie, servidor, mensagem, onesignalId));
                            });
                        
                            await Promise.all(promises);
                        });                     
                        
                        Swal({
                            title: 'Mensagem em massa enviada para todos com sucesso!',
                            icon: 'success',
                            buttons: {
                                confirm: 'Ok',
                            },
                        }).then((res) => {
                            window.location.reload();
                        });
                    });

                } else if (destinatario === 'outros'){
                    
                    return new Promise( async (resolve, reject) => {
                    
                        if (dados.length > 0) {
                            await dados.forEach( async (dado) => {
            
                                const responsavel = dado.responsavel;
                                const serie = dado.serie;
                                const aluno = dado.aluno;
                                const onesignalId = dado.onesignalId;
                                
                                await enviarMensagemParaResponsavel(responsavel, serie, servidor, mensagem, onesignalId)
                                
                            });
                            
                            Swal({
                                title: 'Mensagem em massa enviada para outros com sucesso!',
                                icon: 'success',
                            }).then((res) => {
                                window.location.reload();
                            });
            
                        } else {
                            Swal({
                                title: 'Escolha pelo menos um aluno!',
                                icon: 'error',
                            });
                        }

                    });

                } else if (destinatario !== 'todos') {
                    
                    return new Promise( async (resolve, reject) => {
                        let serieEncontrada = false;
                        const snapshot = await db.collection(ANO)
                            .doc('series')
                            .collection('existente')
                            .get();

                        await Promise.all( snapshot.docs.map( async (val) => {
                            const serie = val.id;
                            if (serie.includes(destinatario)) {
                                serieEncontrada = true;

                                const serieSnapshot = await db.collection(ANO)
                                    .doc('series')
                                    .collection(serie)
                                    .get();

                                await Promise.all(serieSnapshot.docs.map(async (val) => {
                                    const responsavel = val.data().responsavel;
                                    const onesignalId = val.data().onesignalId;
                                    await enviarMensagemParaResponsavel(responsavel, serie, servidor, mensagem, onesignalId);
                                }));

                                Swal({
                                    title: `Mensagem em massa enviada para a ${serie} com sucesso!`,
                                    icon: 'success',
                                    buttons: {
                                        confirm: 'Ok',
                                    },
                                }).then((res) => {
                                    window.location.reload();
                                });
                                return true;
                            }
                        }));

                        if (!serieEncontrada) {
                            Swal({
                                title: 'Nenhuma série encontrada!',
                                icon: 'error',
                            });
                            return false;
                        }
                    });
                }
            } else {
                Swal({
                    title: 'Mensagem inválida!',
                    icon: 'error',
                });
            }   
        } else {
            Swal({
                title: 'Destinatário inválido!',
                icon: 'error',
            });
        }
    } catch (error) {
        console.log(error);
    }
};

const lerMensagensAprovar = async (servidor) => {
    return new Promise( async (resolve, reject) => {
        const mensagens = [];
        try {
            const ANO = await localStorage.getItem('anoFiltrado');
            const mensagensRef = database.ref(`${ANO}/aprovarMensagem`);

            mensagensRef.limitToLast(30).on('child_added', (snapshot) => {
                const uid = snapshot.key;
                const mensagem = snapshot.val();
                if (mensagem.servidor === servidor) {
                    const mensagemObj = {
                        mensagem: mensagem.mensagem,
                        hora: mensagem.hora,
                        usuario: mensagem.usuario,
                        onesignalId: mensagem.onesignalId,
                        responsavel: mensagem.responsavel,
                        aluno: mensagem.aluno,
                        servidor: mensagem.servidor,
                        serie: mensagem.serie,
                        id: uid,
                    };
                    mensagens.push(mensagemObj);
                }
            });

            mensagensRef.on('value', () => {
                resolve(mensagens);
            });
        } catch (error) {
            reject(error);
            console.error('Erro ao obter mensagens:', error);
        }
    });
}


const aceitarMensagemAprovar = async (servidor, serie, responsavel, mensagem, professor, id, onesignalId) => {

    if (mensagem && mensagem !== '') {
        
        return new Promise( async (resolve, reject) => {
            
            const ANO = await localStorage.getItem('anoFiltrado');

            const responsavelRef = database.ref(`${ANO}/chat/${serie}/${responsavel}`);
            await responsavelRef.update({ nome: responsavel });
            
            if (servidor === 'professor') {
            
                await enviarNotificacaoParaResponsavel(mensagem, onesignalId);
                
                const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagensprofessor`);
                await mensagensRef.push({
                    hora: hora,
                    usuario: professor,
                    mensagem: mensagem,
                    data: firebase.database.ServerValue.TIMESTAMP,
                    servidor: 'professor',
                    serie: serie,
                });

                const notificationRef = database.ref(`${ANO}/notification/${responsavel}`);
                await notificationRef.push({
                    hora: hora,
                    usuario: professor,
                    mensagem: mensagem,
                    data: firebase.database.ServerValue.TIMESTAMP,
                    servidor: 'professor',
                    serie: serie,
                });
            } else if (servidor === 'responsavel') {
                
                await db.collection(ANO)
                .doc('restrito')
                .collection('professor')
                .doc('login')
                .collection('acessos')
                .onSnapshot((data) => {
                    data.docs.map( async (val) => {
                        const onesignalId = val.data().onesignalId;
                        await enviarNotificacaoParaServidor(responsavel, mensagem, onesignalId);
                    });
                });
                
                const mensagensRef = database.ref(`${ANO}/chat/${serie}/${responsavel}/mensagensprofessor`);
                await mensagensRef.push({
                    hora: hora,
                    usuario: responsavel,
                    mensagem: mensagem,
                    data: firebase.database.ServerValue.TIMESTAMP,
                    servidor: 'responsavel',
                    serie: serie,
                });

                const notificationRef = database.ref(`${ANO}/notification/professor`);
                await notificationRef.push({
                    hora: hora,
                    usuario: responsavel,
                    mensagem: mensagem,
                    data: firebase.database.ServerValue.TIMESTAMP,
                    servidor: 'responsavel',
                    serie: serie,
                });
            }
            

            const serieExistenteRef = database.ref(`${ANO}/chat/existente/${serie}`);
            await serieExistenteRef.update({ serie: serie });
            
            const mensagemRef = database.ref(`${ANO}/aprovarMensagem/${id}`);
            await mensagemRef.remove();
            
            await Swal({
                title: 'Mensagem enviada com sucesso!',
                icon: 'success',
                buttons: {
                    confirm: 'Ok',
                },
            }).then((res) => {
                //window.location.reload();
            });

            resolve(true);
            
        });
    } else {
        Swal({
            title: 'Digite uma mensagem!',
            icon: 'error',
        });
    }
    
};

const rejeitarMensagemAprovar = (id) => {
    return new Promise( async (resolve, reject) => {
        const ANO = await localStorage.getItem('anoFiltrado');

        const mensagemRef = database.ref(`${ANO}/aprovarMensagem/${id}`);
        await mensagemRef.remove();

        Swal({
            title: 'Mensagem rejeitada com sucesso!',
            icon: 'success',
        }).then(() => {
            window.location.reload();
        });

        resolve(true);
    });
};

export { ANO, lerAlunos, lerTodosAlunos, lerResponsavel, lerMensagensDoResponsavel, lerMensagensDoServidor, enviarMensagemDoResponsavel, enviarMensagemParaResponsavel, enviarMensagemParaServidor, enviarMensagemEmMassa, enviarMensagemDoProfessor, lerMensagensAprovar, aceitarMensagemAprovar, rejeitarMensagemAprovar, enviarNotificacaoParaTodos };